export default __webpack_public_path__ + "static/media/file_right_img.aa5bf46a.png";